import React, { memo, useCallback, useEffect } from 'react';

import {
    Col,
    Image,
    Panel,
    Text,
} from 'reaxl';
import { sendImpressions } from 'reaxl-analytics';
import { InventoryListingV2 } from 'reaxl-listing';

import getSpotlightUrgencyDriver from '@/utilities/getSpotlightUrgencyDriver';
import useInventoryListingProps from '@/utilities/useInventoryListingProps';

import { inventoryImpressions } from '@/analytics/srpAnalyticsHandlers';

import useVehicleHighlightUrgencyDrivers from './hooks/useVehicleHighlightUrgencyDrivers';

function PremiumSpotlightContainer({
    premiumSpotlight,
    listingIndex,
    withUrgencyDriverIcon = false,
}) {
    const getListingProps = useInventoryListingProps();

    const {
        type: urgencyDriverType,
        imgSrc: urgencyDriverImgSrc,
        heading: urgencyDriverHeading,
        subText: urgencyDriverSubText,
    } = useVehicleHighlightUrgencyDrivers({ listing: premiumSpotlight }, true);

    const showUrgencyDriver = urgencyDriverType !== 'default';

    const sendListingImpression = useCallback(() => {
        sendImpressions({
            name: inventoryImpressions,
            data: {
                cmp: getSpotlightUrgencyDriver(urgencyDriverType),
                selectedItemIds: [premiumSpotlight?.id],
            },
        });
    }, [premiumSpotlight?.id, urgencyDriverType]);

    useEffect(() => {
        if (premiumSpotlight) {
            sendListingImpression();
        }
    }, [premiumSpotlight, premiumSpotlight?.id, sendListingImpression]);

    return premiumSpotlight && (
        <Col
            xs={12}
            sm={6}
            md={4}
            className="display-sm-flex"
        >
            <Panel
                data-cmp="PremiumSpotlightContainer"
                key="PremiumSpotlightContainer"
                className="bg-brand-secondary display-flex flex-column"
            >
                {showUrgencyDriver && (
                    <div
                        data-cmp="UrgencyDriver"
                        className="display-flex align-items-center padding-3 gap-3"
                    >
                        {withUrgencyDriverIcon && (
                            <Image
                                height={32}
                                width={32}
                                src={urgencyDriverImgSrc}
                                alt=""
                            />
                        )}
                        <Text
                            componentClass="div"
                            weight="bold"
                            className="line-height-sm"
                        >
                            <Text
                                componentClass="div"
                                color="blue-darker"
                                size={400}
                            >
                                {urgencyDriverHeading}
                            </Text>
                            <Text color="success">
                                {urgencyDriverSubText}
                            </Text>
                        </Text>
                    </div>
                )}
                <div>
                    <InventoryListingV2
                        uiContext="simplified"
                        {...getListingProps('peekaboo', premiumSpotlight, listingIndex)}
                    />
                </div>
            </Panel>
        </Col>
    );
}

export default memo(PremiumSpotlightContainer);
